<template>
  <v-dialog
    :model-value="props.modelValue"
    @update:model-value="changeModelState"
    :max-height="800"
    :max-width="752"
    @after-leave="$emit('after-leave')"
  >
    <v-card class="rounded-lg">
      <v-card-title class="popUpCardTitle pa-4 d-flex justify-space-between align-center">
        <span class="title-popup">Vincular processo</span>
        <v-btn icon variant="text" size="small" @click="onExit">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-8 scrollable-card-text">
        <p class="text-body-2 mb-6">
          <strong>Atenção:</strong> Lembre-se, esse modelo é treinado apenas para processo de aquisição de novos alunos.
        </p>

        <div class="mb-6">
          <label class="text-body-2 font-weight-medium mb-2 d-block">Processo</label>
          <p class="text-body-2 text-medium-emphasis mb-2">
            Escolha o processo de captação que você deseja receber a probabilidade de conversão.
          </p>
          <v-autocomplete
            :key="processSelected"  
            v-model="processSelected"
            :items="processes"
            item-title="nome"
            item-value="id"
            density="comfortable"
            placeholder="Escolha o processo"
            clearable
            @blur="processTouched = true"
            :error="processTouched && !processSelected"
            :error-messages="processTouched && !processSelected ? ['Selecione um processo'] : []"
          />
        </div>

        <div class="mb-6">
          <label class="text-body-2 font-weight-medium mb-2 d-block">Período da campanha</label>
          <p class="text-body-2 text-medium-emphasis mb-2">
            Selecione a data de referência do início da sua campanha atual. Todos os registros criados ou alterados dentro do período receberão as atualizações.
          </p>
          <v-date-input
            v-model="dateRegister"
            class="input-data-picker"
            label="A partir do dia"
            density="comfortable"
            prepend-icon=""
            append-inner-icon="mdi-calendar"
            @blur="dateTouched = true"
            :error="dateTouched && !dateRegister"
          />
        </div>

        <div class="mb-6">
          <label class="text-body-2 font-weight-medium mb-2 d-block">Etapas</label>
          <p class="text-body-2 text-medium-emphasis mb-2">
            Selecione uma ou mais etapas que representam uma conversão no processo.
          </p>
          <v-autocomplete  
            v-model="etapasSelected"
            :items="etapasOptions"
            item-title="titulo"
            item-value="id"
            density="comfortable"
            placeholder="Escolha as etapas de conversão"
            multiple
            chips
            closable-chips
            :disabled="!processSelected"
            @blur="etapasTouched = true"
            :error="etapasTouched && (!etapasSelected || etapasSelected.length === 0) && !!processSelected"
            :error-messages="etapasTouched && (!etapasSelected || etapasSelected.length === 0) && !!processSelected ? ['Selecione ao menos 1 etapa'] : []"
          >
            <template v-slot:item="{ props, item }">
              <v-list-item
                v-bind="props"
                :active="false"
                :title="item.raw.titulo"
              >
                <template v-slot:prepend="{ isSelected }">
                  <v-checkbox-btn :model-value="isSelected"></v-checkbox-btn>
                </template>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>

        <div>
          <label class="text-body-2 font-weight-medium mb-2 d-block">Público-alvo</label>
          <p class="text-body-2 text-medium-emphasis mb-2">
            Defina o público-alvo para o qual as predições serão geradas.
          </p>
          
          <v-autocomplete
            v-model="edulevelsSelected"
            v-model:menu="menus.edulevels"
            :items="edulevels"
            item-title="titulo"
            item-value="id"
            label="Nível de ensino"
            multiple
            chips
            closable-chips
            density="comfortable"
            :disabled="!processSelected"
            :hide-no-data="true"
            :no-filter="false"
          >
            <template #prepend-item>
              <v-list-item @click.stop :active="false">
                <v-checkbox
                  v-model="allEduChecked"
                  label="Selecionar todos"
                  density="compact"
                  hide-details
                  :indeterminate="isSomeSelectedSimple(edulevelsSelected, edulevels)"
                  @mousedown.prevent
                  @click.stop
                />
              </v-list-item>
              <v-divider class="mt-1" />
            </template>

            <template #item="{ props: itemProps, item: opt }">
              <v-list-item v-bind="itemProps" :active="false" :title="opt.raw.titulo" @click.stop>
                <template #prepend>
                  <v-checkbox
                    density="compact"
                    hide-details
                    :model-value="(edulevelsSelected || []).map(String).includes(String(opt.raw.id))"
                    @mousedown.prevent
                    @click.stop
                    @update:model-value="(v) => onToggleSingleSimple(edulevelsSelected, 'edulevels', edulevels, opt.raw.id, v)"
                  />
                </template>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="modalitiesSelected"
            v-model:menu="menus.modalities"
            :items="modalities"
            item-title="titulo"
            item-value="id"
            label="Modalidade"
            multiple
            chips
            closable-chips
            density="comfortable"
            :disabled="!processSelected"
            :hide-no-data="true"
            :no-filter="false"
          >
            <template #prepend-item>
              <v-list-item @click.stop :active="false">
                <v-checkbox
                  v-model="allModChecked"
                  label="Selecionar todos"
                  density="compact"
                  hide-details
                  :indeterminate="isSomeSelectedSimple(modalitiesSelected, modalities)"
                  @mousedown.prevent
                  @click.stop
                  :ripple="false"
                />
              </v-list-item>
              <v-divider class="mt-1" />
            </template>

            <template #item="{ props: itemProps, item: opt }">
              <v-list-item v-bind="itemProps" :active="false" :title="opt.raw.titulo" @click.stop>
                <template #prepend>
                  <v-checkbox
                    density="compact"
                    hide-details
                    :model-value="(modalitiesSelected || []).map(String).includes(String(opt.raw.id))"
                    @mousedown.prevent
                    @click.stop
                    @update:model-value="(v) => onToggleSingleSimple(modalitiesSelected, 'modalities', modalities, opt.raw.id, v)"
                  />
                </template>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="offersSelected"
            v-model:menu="menus.offers"
            :items="offers"
            item-title="titulo"
            item-value="id"
            label="Locais"
            multiple
            chips
            closable-chips
            density="comfortable"
            :disabled="!processSelected"
            :hide-no-data="true"
            :no-filter="false"
          >
            <template #prepend-item>
              <v-list-item @click.stop :active="false">
                <v-checkbox
                  v-model="allOffChecked"
                  label="Selecionar todos"
                  density="compact"
                  hide-details
                  :indeterminate="isSomeSelectedSimple(offersSelected, offers)"
                  @mousedown.prevent
                  @click.stop
                  :ripple="false"
                />
              </v-list-item>
              <v-divider class="mt-1" />
            </template>

            <template #item="{ props: itemProps, item: opt }">
              <v-list-item v-bind="itemProps" :active="false" :title="opt.raw.titulo" @click.stop>
                <template #prepend>
                  <v-checkbox
                    density="compact"
                    hide-details
                    :model-value="(offersSelected || []).map(String).includes(String(opt.raw.id))"
                    @mousedown.prevent
                    @click.stop
                    @update:model-value="(v) => onToggleSingleSimple(offersSelected, 'offers', offers, opt.raw.id, v)"
                  />
                </template>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-8 py-4 d-flex justify-end">
        <v-btn class="px-6 py-5 d-flex" rounded="xl" variant="outlined" :color="cancelColor" @click="onCancel" :disabled="isSubmitting">
          Cancelar
        </v-btn>
        <v-btn
          class="px-6 py-5 d-flex"
          rounded="xl"
          variant="outlined"
          @click="onConfirmAddAnother"
          :disabled="isSubmitting || isFormInvalid"
        >
          <p class="text-primary-35">Adicionar e vincular novo processo</p>
        </v-btn>

        <v-btn
          variant="elevated"
          color="primary-60"
          class="px-6 py-5 d-flex elevation-0"
          rounded="xl"
          @click="onConfirmClose"
          :disabled="isSubmitting || isFormInvalid"
        >
          Adicionar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, watch, nextTick, reactive, toRefs } from "vue";
import { Post } from "@/ai_studio/http/http";
import { formatDateForApi } from "@/ai_studio/utils/dataformatter";
import { VDateInput } from 'vuetify/labs/VDateInput'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  processes: { type: Array, required: true },
  edulevels: { type: Array, required: true },
  modalities: { type: Array, required: true },
  offers: { type: Array, required: true },
});

const emit = defineEmits(["update:modelValue", "confirm", "cancel", "after-leave"]);

const processSelected = ref(null);
const processTouched = ref(false);
const etapasSelected = ref([]);
const etapasTouched = ref(false);
const dateRegister = ref("");
const dateTouched = ref(false);
const edulevelsSelected = ref([]);
const modalitiesSelected = ref([]);
const offersSelected = ref([]);
const isSubmitting = ref(false);
const menus = reactive({ edulevels: false, modalities: false, offers: false });
const { edulevels, modalities, offers } = toRefs(props);
const hasSavedInSession = ref(false);


const etapasOptions = computed(() => {
  const processo = props.processes.find(p => p.id === processSelected.value);
  return processo ? (processo.etapas || []) : [];
});

const changeModelState = (value) => {
  emit("update:modelValue", value);
};

const isFormInvalid = computed(() => {
  const hasProcess = !!processSelected.value;
  const hasEtapas = Array.isArray(etapasSelected.value) && etapasSelected.value.length > 0;
  const hasDate = !!dateRegister.value;
  return !hasProcess || !hasDate || (hasProcess && !hasEtapas);
});

const toStr = (v) => String(v);
function isAllSelectedSimple(modelRef, options) {
  const allIds = (options || []).map(o => toStr(o.id));
  const sel = (modelRef.value || []).map(toStr);
  return allIds.length > 0 && sel.length === allIds.length && allIds.every(id => sel.includes(id));
}
function isSomeSelectedSimple(modelRef, options) {
  const total = (options || []).length;
  const selLen = (modelRef.value || []).length;
  return selLen > 0 && selLen < total;
}
function toggleSelectAllSimple(modelRef, options, checked) {
  modelRef.value = checked ? (options || []).map(o => o.id) : [];
}
function onToggleAllSimple(modelRef, menuKey, options, checked) {
  toggleSelectAllSimple(modelRef, options, checked);
  nextTick(() => { menus[menuKey] = true; });
}
function toggleSingleSimple(modelRef, options, id, checked) {
  const set = new Set((modelRef.value || []).map(toStr));
  if (checked) set.add(toStr(id)); else set.delete(toStr(id));
  const byId = new Map((options || []).map(o => [toStr(o.id), o.id]));
  modelRef.value = Array.from(set).map(s => byId.get(s) ?? s);
}
function onToggleSingleSimple(modelRef, menuKey, options, id, checked) {
  toggleSingleSimple(modelRef, options, id, checked);
  nextTick(() => { menus[menuKey] = true; });
}

const allEduChecked = computed({
  get: () => isAllSelectedSimple(edulevelsSelected, edulevels.value),
  set: (val) => onToggleAllSimple(edulevelsSelected, 'edulevels', edulevels.value, val),
});
const allModChecked = computed({
  get: () => isAllSelectedSimple(modalitiesSelected, modalities.value),
  set: (val) => onToggleAllSimple(modalitiesSelected, 'modalities', modalities.value, val),
});
const allOffChecked = computed({
  get: () => isAllSelectedSimple(offersSelected, offers.value),
  set: (val) => onToggleAllSimple(offersSelected, 'offers', offers.value, val),
});

watch(processSelected, (novo, antigo) => {
  if (novo !== antigo) {
    etapasSelected.value = [];
    etapasTouched.value = false;
  }
});

const buildPayload = () => ({
  process: processSelected.value,
  steps: etapasSelected.value,
  date: formatDateForApi(dateRegister.value),
  offers: offersSelected.value,
  modalities: modalitiesSelected.value,
  education_levels: edulevelsSelected.value,
});

const resetForm = () => {
  processTouched.value = false;
  dateTouched.value = false;
  etapasTouched.value = false;
  processSelected.value = null;
  etapasSelected.value = [];
  dateRegister.value = "";
  dateTouched.value = false;
  edulevelsSelected.value = [];
  modalitiesSelected.value = [];
  offersSelected.value = [];
};

const submit = async () => {
  dateTouched.value = true;
  processTouched.value = true;
  if (processSelected.value) etapasTouched.value = true;

  if (isFormInvalid.value) return false;

  const payload = buildPayload();
  isSubmitting.value = true;

  try {
    await Post(JSON.stringify(payload), "insights/configuration");
    hasSavedInSession.value = true;
    return true;
  } catch (err) {
    console.error("Erro ao enviar payload:", err);
    return false;
  } finally {
    isSubmitting.value = false;
  }
};

const onConfirmAddAnother = async () => {
  const ok = await submit();
  if (!ok) return;
  resetForm();
};

const onConfirmClose = async () => {
  const ok = await submit();
  if (!ok) return;
  
  emit("update:modelValue", false);
  emit("confirm");
  resetForm();
};

const onCancel = () => {
  emit("cancel");
  resetForm();

  if (hasSavedInSession.value) emit("confirm");

  emit("update:modelValue", false);
  hasSavedInSession.value = false;
};

const onExit = () => {
  resetForm();

  if (hasSavedInSession.value) emit("confirm");

  emit("update:modelValue", false);
  hasSavedInSession.value = false;
};
</script>

<style scoped>
.popUpDivider {
  background-color: #E1E3E2;
  width: 100%;
  height: 1px;
}

.popUpCardTitle {
  background-color: rgb(var(--v-theme-neutral-95));
  color: rgb(var(--v-theme-neutral-35));
  font-size: 16px;
  font-weight: 500;
  padding: 4px 16px 4px 32px !important;
}

.popUpCardText {
  color: #0E1211;
}

.buttonBorder {
  border: 1px solid;
}

.title-popup {
  color: #505353;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.4px;
}

.input-data-picker {
  width: 193px;
}

.scrollable-card-text {
  max-height: 607px;
  overflow-y: auto;
}
</style>
